import type { JSX } from "react";
import type { IconName } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";
import { Container, Icon, TextContainer, Name, Email, PendingEmail } from "./InviteTeammatesListItem.styled";

interface IInviteTeammatesListItemProps {
    email: string;
    name: string;
    isInvite: boolean;
    iconName: IconName;
    onClick: () => void;
    isActive?: boolean;
}

export const InviteTeammatesListItem = ({
    email,
    name,
    isInvite,
    iconName,
    onClick,
    isActive = false,
}: IInviteTeammatesListItemProps): JSX.Element => (
    <Container
        onClick={onClick}
        alignItems="center"
        isActive={isActive}
    >
        <Icon
            iconName={iconName}
            size="sm"
        />
        <TextContainer>
            <Name>{name}</Name>
            <Email>
                {name !== email ? email : null}
                {isInvite ? <PendingEmail>({translate("dashboard.shareDashboard.pending")})</PendingEmail> : null}
            </Email>
        </TextContainer>
    </Container>
);
